export default "__VITE_ASSET__BVQZvGYg__"